import { render, staticRenderFns } from "./QuestionBtn.vue?vue&type=template&id=59dcd902&"
import script from "./QuestionBtn.vue?vue&type=script&lang=js&"
export * from "./QuestionBtn.vue?vue&type=script&lang=js&"
import style0 from "./QuestionBtn.vue?vue&type=style&index=0&lang=stylus&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports